import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  HostListener
} from '@angular/core';
import { Observable } from 'rxjs';
import {
  GridsterComponent,
  IGridsterDraggableOptions,
  IGridsterOptions,
  GridsterItemComponent
} from 'angular2gridster';
import { WidgetsettingsComponent } from '../shared/widgetsettings/widgetsettings.component';
import { appSettings, errorMessages } from '../../settings';
import { CommonService, DashboardService, WidgetService } from '../../services';
import { UserPreference } from '../../models/UserPreference';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import * as moment from 'moment';
//import { NgbModal, ModalDismissReasons, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  @ViewChild(GridsterComponent) gridsterComp: GridsterComponent;

  widgets: Array<any>;
  dashboardWidgets: Array<any>;
  gridsterOptions: IGridsterOptions;
  gridsterDraggableOptions: IGridsterDraggableOptions;
  userPref: UserPreference;
  loading: boolean = false;
  errorMessage: string;
  gridsterItemOptions: any = {
    minWidth: 2,
    minHeight: 2,
    defaultWidth: 2,
    defaultHeight: 3
  };

  addwidgetModalRef: NgbModalRef;
  @ViewChild('addwidget') addwidgetModal;
  widgetdata: any;
  widgetTypes: Array<any>;
  selWidgetType: string;
  isWidgetTypeEmpty: boolean = false;
  widgetDetailInfo: any =null;
  constructor(private _commonService: CommonService,
    private _dashboardService: DashboardService,
    private _widgetService: WidgetService,
    private _ngbModal: NgbModal,
    private router: Router) { }

  @HostListener('window:resize', ['$event'])

  onResize(event) {
    console.log('onResize');
    //set timeout added because the resize is slower than the refreshwidget function call
    setTimeout(() => {
      this.widgets.forEach(widget => {
        this._widgetService.refreshWidget(widget);
      });
    }, 1000);
  };

  ngOnInit() {
    document.getElementById("pageTitle").innerText = "Dashboard";
    this.userPref = this._commonService.getUserPreference();
    this.gridsterOptions = this._widgetService.gridsterOptions;
    this.gridsterDraggableOptions = this._widgetService.gridsterDraggableOptions;
    this.loadWidgets();
  }

  ngOnDestroy() {
    console.log('Dashboard OnDestroy');
    this._dashboardService.closeConnections();
    //this.gridsterComp.reload();
    if (this.gridsterComp) {
      this.gridsterComp.ngOnDestroy();
    }

    if (this.addwidgetModalRef) {
      this.addwidgetModalRef.close();
    }
  }

  facilityChanged(e) {
    this.widgetTypes = null;
    console.log('facilityChanged', e);
    this.loadWidgets();
  }

  onReflow(event: any) {
    console.log('onReflow', event);
  }

  optionsChange(options: IGridsterOptions) {
    console.log('optionsChange:', options);
    this.gridsterOptions = options;
  }

  //eCharts Events
  //echartsIntance : any;
  onChartInit(e: any) {
    console.log('onChartInit', e);
    //this.echartsIntance = e;
    this.resizeChart(e);
  }

  resizeChart(e: any) {
    console.log('resizeChart', e);
    if (e) {
      e.resize();
    }
  }
  closeChartDetail(val){
    this.widgetdata=null;
    this.widgetDetailInfo=null;
  }
  onChartClick(e: any, widget: any) {
    if (widget.DetailAPI && widget.DetailAPI != '') {
      let widgetData = {
        DetailAPI: widget.DetailAPI,
        type: widget.type,
        DisplayColumn: widget.DisplayColumn,
        DataColumn: widget.DataColumn,
        DataType: widget.DataType,
        Level2DetailAPI: widget.Level2DetailAPI,
        Level2DataColumn: widget.Level2DataColumn,
        Level2DisplayColumn: widget.Level2DisplayColumn,
        Level2DataType: widget.Level2DataType,
        Title: widget.Title,
        widgetsettings: widget.widgetsettings
      };
      if(widgetData.type == appSettings.AgedTasks 
          || widgetData.type == appSettings.AgedOrdersPutwall
          || widgetData.type == appSettings.TimeInCubby){
        let dateObject = this.setWidgetDates(e.name);
        if(widgetData && widgetData.widgetsettings && dateObject){
          let criteria = JSON.parse(widgetData.widgetsettings.Criteria);
          criteria = criteria ? criteria : {};
          criteria.StartDate = dateObject.StartDate;
          criteria.EndDate = dateObject.EndDate;
          widgetData.widgetsettings.Criteria = JSON.stringify(criteria);
        }
      }
      else if(widgetData.type == appSettings.OpenPicksTask){      
        if(widgetData && widgetData.widgetsettings && e.name && e.name != ''){
          let criteria = JSON.parse(widgetData.widgetsettings.Criteria);
          criteria = criteria ? criteria : {};
          criteria.TaskRefNumber = e.name;        
          widgetData.widgetsettings.Criteria = JSON.stringify(criteria);
        }      
      }
      else if(widgetData.type == appSettings.AgedOrders){      
        if(widgetData && widgetData.widgetsettings && e.name && e.name != ''){
          let criteria = JSON.parse(widgetData.widgetsettings.Criteria);
          criteria = criteria ? criteria : {};
          criteria.ReportDate = e.name;        
          widgetData.widgetsettings.Criteria = JSON.stringify(criteria);
        }
      }
      else if(widgetData.type == appSettings.HospitalSummary){  
        let hourObject = this.setWidgetHours(e.name);    
        if(widgetData && widgetData.widgetsettings && e.name && e.name != ''){
          let criteria = JSON.parse(widgetData.widgetsettings.Criteria);
          criteria = criteria ? criteria : {};
          criteria.ReportDate = moment(new Date()).format("l");   
          criteria.StartHours = hourObject.StartHours;
          criteria.EndHours = hourObject.EndHours;     
          widgetData.widgetsettings.Criteria = JSON.stringify(criteria);
        }
      }
      else if(widgetData.type == appSettings.BlindCountError 
        || widgetData.type == appSettings.ForceClosedPackwaves 
        || widgetData.type == appSettings.ToteRecirculating){  
        if(widgetData && widgetData.widgetsettings && e.name && e.name != ''){
          let criteria = JSON.parse(widgetData.widgetsettings.Criteria);
          criteria = criteria ? criteria : {};
          criteria.selectedDate = moment(e.name).format("l");   
          widgetData.widgetsettings.Criteria = JSON.stringify(criteria);
        }
      }
      else if(widgetData.type == appSettings.MHENoReadData){  
        if(widgetData && widgetData.widgetsettings && e.name && e.name != ''){
          let criteria = JSON.parse(widgetData.widgetsettings.Criteria);
          criteria = criteria ? criteria : {};
          criteria.selectedDate = e.name;   
          if(!criteria.SummaryType) {
            criteria.SummaryType = 'D';
          }
          widgetData.widgetsettings.Criteria = JSON.stringify(criteria);
        }
      }
      var appBody = document.getElementById("appBody");
      appBody.className ="no-scroll"; 
      this.widgetdata = widgetData;
    } 
  }

  loadWidgets() {
    this.userPref = this._commonService.getUserPreference();
    this.errorMessage = "";
    if (this.userPref) {
      this.loading = true;
      this.widgets = [];
      this.dashboardWidgets = [];
      //close existing open connections
      this._dashboardService.closeConnections();
      console.time('getWidgets');
      this._dashboardService.getWidgets(this.userPref.UserId, this.userPref.FacilityId, this.userPref.CustomerId)
        .subscribe(data => {
          console.timeEnd('getWidgets');

          if (data && data.length > 0) {
            this.dashboardWidgets = data;
            this.widgets = this._widgetService.transformWidgets(data);
            this.renderWidgets(this.widgets);
          }
          else {
            this.errorMessage = errorMessages.emptyDashboard;
          }
          this.loading = false;
        }, error => {
          //Exception log
          console.timeEnd('getWidgets');
          console.log('getWidgets', error);
          this.loading = false;
        });
    }
  }

  renderWidgets(widgets: Array<any>) {
    widgets.forEach(item => {
      this._widgetService.loadWidget(item);
    });
  }

  itemChange(event: any, widget: any, gridster: any) {
    if (event.breakpoint == "lg") {
      console.log('itemChange');
      this._widgetService.refreshWidget(widget);
      if (this.isWidgetUpdated(event, widget.widgetId)) {
        console.log('Item changed : ' + widget.Title);
        //console.log(event);
        widget.h = event.item.h;
        widget.w = event.item.w;
        widget.y = event.item.y;
        widget.x = event.item.x;
        this.saveWidgetGridSettings(widget);
      }
    }
  }

  isWidgetUpdated(event: any, widgetId: number): boolean {
    if (this.dashboardWidgets && this.dashboardWidgets.length > 0) {
      let item = this.dashboardWidgets.filter(x => x.widgetId == widgetId)[0];
      if (event.changes && event.changes.length > 0) {
        let gridOptions = this._widgetService.transformWidget(item);
        if (gridOptions.h != event.item.h || gridOptions.w != event.item.w
          || gridOptions.y != event.item.y || gridOptions.x != event.item.x) {
          return true;
        }
      }
    }
    return false;
  }

  getWidgetTypes() {
    let widgets: Array<any> = [];
    if (this.userPref) {
      this.userPref = this._commonService.getUserPreference();
    }
    this.loading = true;
    console.time('getWidgetTypes');
    this._dashboardService.getWidgetTypes(this.userPref.FacilityId, this.userPref.CustomerId)
      .subscribe(response => {
        console.timeEnd('getWidgetTypes');
        this.loading = false;

        if (response && response.length > 0) {
          response.forEach(element => {
            widgets.push({ label: element.WidgetTypeTitle, value: element.WidgetTypeName });
          });
        }
        this.widgetTypes = widgets;
      },
        error => {
          //Exception log
          console.timeEnd('getWidgetTypes');
          console.log('getWidgetTypes', error);
          this.loading = false;
          this.widgetTypes = widgets;
        });
  }

  AddWidgetPopup() {
    //reset previous selection
    this.selWidgetType = null;
    this.isWidgetTypeEmpty = false;
    if(!this.widgetTypes)
      this.getWidgetTypes();
    let options: NgbModalOptions;
    options = {
      backdrop: "static",
      keyboard: false//,
      //size: "lg"
    };
    this.addwidgetModalRef = this._ngbModal.open(this.addwidgetModal, options);
  }

  AddChart() {
    if (this.selWidgetType) {
      this.isWidgetTypeEmpty = false;
      console.log('AddChart', this.selWidgetType);
      if (this.userPref) {
        this.userPref = this._commonService.getUserPreference();
      }

      //Setting height to 2 to fix issue pie charts were overlapping
      let widgetWidth = 3;let widgetHeight = 3;
      switch(this.selWidgetType){
          case appSettings.WaveOrdStatus:
          case appSettings.PutwallOrderStatus:
          case appSettings.CubbyOrderStatus:
            widgetHeight = 2;
          break;
          case appSettings.HospitalPackedOrderSummary:
          case appSettings.MHEMonitoringSummary:
            widgetWidth = 6; //adjusted width for grid
          break;
          case appSettings.CancelOrders:
            widgetWidth = 5; //adjusted width for grid
            widgetHeight = 2;
          break;
      }

      let widgetData = {
        Name: this.widgetTypes.filter(x => x.value == this.selWidgetType)[0].label,
        Type: this.selWidgetType,
        width: widgetWidth,
        height: widgetHeight,
        positionX: -1,
        positionY: 0,
        customerId: this.userPref.CustomerId
      };

      console.time('addWidget');
      this.loading = true;
      this._dashboardService.addWidget(this.userPref.UserId, this.userPref.FacilityId, this.userPref.CustomerId, widgetData)
        .subscribe(data => {
          console.timeEnd('addWidget');
          if (data) {
            //reset selection
            this.selWidgetType = null;
            this.isWidgetTypeEmpty = false;
            let newWidget = {
              Type: data.type,
              Sizewidth: 3,
              Sizeheight: widgetHeight,
              RefreshInterval: null,//"08:00",
              ShipmentType: ["ALL"],
              OrderPriority: ["ALL"],
              Carrier: ["ALL"],
              AppointmentDate: null,
              ShipToCountryCode: ["ALL"],
              ItemNumber: null,
              IsPast: 'Y',
              IsCurrent: 'Y',
              IsFuture: 'Y',
              IsLithium: 'B',
              PickType: 'PostShip',
              ZoneAisle: null,
              PassThrus: [],
              widgetId: data.widgetId,
              PositionX: 0,
              PositionY: 0,
              MonitorType: 'ORDERS',
              WaveCode: '0',
              WaveTitle: 'All Waves',
              Criteria:''
            };
            this.loadWidgets();
            this.addwidgetModalRef.close(newWidget);
          }
          else {
            this.loading = false;
          }
        },
          err => {
            console.timeEnd('addWidget');
            console.log('Error addWidget', err);
            this.addwidgetModalRef.close(null);
            this.loading = false;
          });
    }
    else {
      this.isWidgetTypeEmpty = true;
    }
  }

  remove($event: any, index: number, widget: any) {
    $event.preventDefault();
    this.userPref = this._commonService.getUserPreference();
    //Step 1 : disable thread
    this.widgets.splice(index, 1);
    this._widgetService.removeWidget(widget);
    if (this.widgets.length == 0) {
      this.errorMessage = errorMessages.emptyDashboard;
    }
    this.loading = true;
    console.time('removewidget');
    this._dashboardService.removeWidget(widget.widgetId, this.userPref.UserPreferenceId)
      .subscribe(data => {
        console.timeEnd('removewidget');
        console.log("Remove widget completed");
        //this.loadWidgets();
        this.loading = false;
      }, error1 => {
        //Exception log
        console.timeEnd('removewidget');
        console.log('removewidget', error1);
        this.loading = false;
      })
  }

  editWidget(widget: any, event: any): void {
    let options: NgbModalOptions;
    options = {
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    };
    if (widget.type == appSettings.ProgressTracking) {
      options.size = 'lg';
    }

    const editModal = this._ngbModal.open(WidgetsettingsComponent, options);
    editModal.componentInstance.edit = true;
    editModal.componentInstance.widget = widget;
    editModal.result.then((result) => {
      console.log('edited', result);
      //Reload the widget
      if (result != "Close") {
        let widget = result;
        let updatedItem = this.widgets.filter(x => x.widgetId == widget.widgetId)[0];
        updatedItem.widgetsettings = widget.widgetsettings;
        this._widgetService.reloadWidget(updatedItem);
      }

    }, () => { })
  }

  saveWidgetGridSettings(widget: any) {
    let widgetlist: Array<any> = [];
    widgetlist.push({
      positionX: widget.x,
      positionY: widget.y,
      width: widget.w,
      height: widget.h,
      widgetId: widget.widgetId
    });
    console.time('saveWidgetlocation :' + widget.widgetId);
    this._dashboardService.saveWidgetlocation(widgetlist)
      .subscribe(data => {
        console.timeEnd('saveWidgetlocation :' + widget.widgetId);
      },
        err => {
          console.timeEnd('saveWidgetlocation :' + widget.widgetId);
          console.log('saveWidgetlocation', err);
        }
      );
  }

  next10(widget) {
    console.log('next10');
    widget.startWave = widget.startWave + 10;
    widget.endWave = widget.startWave + 10;
    this._widgetService.reloadWidget(widget);
  }

  previous10(widget) {
    console.log('previous10');
    widget.startWave = widget.startWave - 10;
    widget.endWave = widget.startWave + 10;
    this._widgetService.reloadWidget(widget);
  }

  public OrderDetailEvent(objOrderDetail: any): void {
    console.log(' OrderDetailEvent',objOrderDetail)
    if (objOrderDetail) {
      this.widgetDetailInfo = objOrderDetail;
      var appBody = document.getElementById("appBody");
      appBody.className ="no-scroll";
    }
  }

  setWidgetHours(selectedBar) : any{
    let widgetHour : any = {};
    switch(selectedBar.toUpperCase()){
      case 'BELOW 1 HR':
        widgetHour.StartHours = 0;
        widgetHour.EndHours = 1;
      break;
      case '1-3 HRS':
        widgetHour.StartHours = 1;
        widgetHour.EndHours = 3;
      break;
      case '3-5 HRS':
        widgetHour.StartHours = 3;
        widgetHour.EndHours = 5;
      break;
      case '5-7 HRS':
        widgetHour.StartHours = 5;
        widgetHour.EndHours = 7;
      break;
      case '7-24 HRS':
        widgetHour.StartHours = 7;
        widgetHour.EndHours = 24;
      break;
      case 'ABOVE 24 HRS':             
        widgetHour.StartHours = 24;
        widgetHour.EndHours = 9999;
      break;
    }
    return widgetHour;
  }

  setWidgetDates(selectedBar) : any{
    let widgetDate : any = {}; let dateFormat = 'YYYY-MM-DD[T]HH:mm:ss';
    switch(selectedBar.toUpperCase()){
      case '0-1 HRS':
      case 'BELOW 1 HR':     
        widgetDate.StartDate = moment(new Date()).add(-1,'hours').format(dateFormat);
        widgetDate.EndDate = moment(new Date()).format(dateFormat);        
      break;
      case '1-2 HRS':     
        widgetDate.StartDate = moment(new Date()).add(-2,'hours').format(dateFormat);
        widgetDate.EndDate = moment(new Date()).add(-1,'hours').format(dateFormat);
      break;
      case '1-3 HRS':     
        widgetDate.StartDate = moment().add(-3,'hours').format(dateFormat);
        widgetDate.EndDate = moment().add(-1,'hours').format(dateFormat);
      break;
      case '2-4 HRS':     
      widgetDate.StartDate = moment().add(-4,'hours').format(dateFormat);
      widgetDate.EndDate = moment().add(-2,'hours').format(dateFormat);
      break;
      case 'BELOW 5 HRS':     
        widgetDate.StartDate = moment().add(-5,'hours').format(dateFormat);
        widgetDate.EndDate = moment(new Date()).format(dateFormat);
      break;
      case '3-5 HRS':     
        widgetDate.StartDate = moment().add(-5,'hours').format(dateFormat);
        widgetDate.EndDate = moment().add(-3,'hours').format(dateFormat);
      break;
      case '5-7 HRS':     
        widgetDate.StartDate = moment().add(-7,'hours').format(dateFormat);
        widgetDate.EndDate = moment().add(-5,'hours').format(dateFormat);
      break;
      case '4-8 HRS':     
      widgetDate.StartDate = moment().add(-8,'hours').format(dateFormat);
      widgetDate.EndDate = moment().add(-4,'hours').format(dateFormat);
      break;
      case '5-10 HRS':     
        widgetDate.StartDate = moment().add(-10,'hours').format(dateFormat);
        widgetDate.EndDate = moment().add(-5,'hours').format(dateFormat);
      break;
      case '7-10 HRS':     
        widgetDate.StartDate = moment().add(-10,'hours').format(dateFormat);
        widgetDate.EndDate = moment().add(-7,'hours').format(dateFormat);
      break;
      case '10-15 HRS':     
      widgetDate.StartDate = moment().add(-15,'hours').format(dateFormat);
      widgetDate.EndDate = moment().add(-10,'hours').format(dateFormat);
      break;
      case '7-24 HRS':     
        widgetDate.StartDate = moment().add(-24,'hours').format(dateFormat);
        widgetDate.EndDate = moment().add(-7,'hours').format(dateFormat);
      break;
      case '8-24 HRS':     
        widgetDate.StartDate = moment().add(-24,'hours').format(dateFormat);
        widgetDate.EndDate = moment().add(-8,'hours').format(dateFormat);
      break;
      case '15-24 HRS':     
        widgetDate.StartDate = moment().add(-24,'hours').format(dateFormat);
        widgetDate.EndDate = moment().add(-15,'hours').format(dateFormat);
      break;
      case '10-24 HRS':     
        widgetDate.StartDate = moment().add(-24,'hours').format(dateFormat);
        widgetDate.EndDate = moment().add(-10,'hours').format(dateFormat);
      break;
      case 'ABOVE 24 HRS':
      case 'ABOVE 1 DAY':               
        widgetDate.EndDate = moment().add(-24,'hours').format(dateFormat);
      break;
    }
    return widgetDate;
  }


}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts